import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import './Profile.css';

const Profile = () => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const lastLogin = user.metadata?.lastSignInTime
    ? new Date(user.metadata.lastSignInTime).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    : 'N/A';

  return (
    <div className="profile-wrapper">
  <div className="card profile-card shadow">
    <div className="profile-heading text-center">My Profile</div>

    <div className="text-center">
      <p><strong>Name:</strong> {user.displayName || 'No name available'}</p>
      <p><strong>Email:</strong> {user.email}</p>
      <p><strong>Last Login:</strong> {lastLogin}</p>
    </div>


      <div className="mt-4 text-center">
  <Link to="/change-password" className="btn btn-warning fw-bold me-2">
    Change Password
  </Link>
  <Link to="/" className="btn btn-light fw-bold">
    Back to Home
  </Link>
</div>

{/* 🔔 Job Alerts Section */}
<hr className="mt-4" />
<div className="text-center">
  <h2 style={{ fontSize: '26px', fontWeight: 'bold', color: '#1d4ed8', marginBottom: '1rem' }}>
    🔔 Job Alerts
  </h2>
  <a
    href={`${process.env.REACT_APP_FRONTEND_URL}/subscribe`}
    className="btn btn-primary btn-sm me-2"
    style={{ marginRight: '10px' }}
  >
    Subscribe
  </a>
  <a
    href={`${process.env.REACT_APP_FRONTEND_URL}/unsubscribe`}
    className="btn btn-danger btn-sm"
  >
    Unsubscribe
  </a>
</div>

      </div>
    </div>
  );
};

export default Profile;
